import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import HomeService from "../Services/HomeService";
import CityDateService from "../Services/CityDateService";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "rgb(131, 144, 155)",
  margin: "0px 0px 10px 0px",
  fontWeight: "bold",
};

function AddCityDate() {
  const navigate = useNavigate();
  const userCity = localStorage.getItem("city");

  const [cities, setCities] = useState([]);
  const [cityId, setCityId] = useState("");
  const [rawDate, setRawDate] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      if (res?.data) {
        let cityList = res.data;
        if (userCity) {
          const filtered = cityList.filter((item) => item._id === userCity);
          if (filtered.length > 0) cityList = filtered;
        }
        setCities(cityList);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
      toast.error("Failed to load cities!");
    }
  };

  useEffect(() => {
    fetchCities();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!cityId) {
      toast.error("Please select a city");
      return;
    }

    if (!rawDate) {
      toast.error("Please select a date");
      return;
    }

    const formattedDate = moment(rawDate).format("DD-MM-YYYY");

    setLoading(true);
    try {
      const payload = {
        city: cityId,
        date: formattedDate,
      };

      const res = await CityDateService.createCityDate(payload);

      if (res?.status === false || res?.statusCode === 400 || res?.status === 400) {
        toast.error(
          res?.message ||
            "A record for this city already exists. Use the update API to change the date."
        );
      } else if (res?.status || res?.data || res?._id) {
        toast.success("City date added successfully!");
        clearForm();
        navigate("/manage-city-date");
      } else {
        toast.error(res?.message || "Failed to add City Date.");
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to add City Date.";
      toast.error(errMsg);
      console.error("Error adding City Date:", error);
    } finally {
      setLoading(false);
    }
  };

  const clearForm = () => {
    setCityId("");
    setRawDate("");
  };

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid">
        <div className="mt-5">
          <div style={headLineStyle} className="page-headline">
            Add City With Date
          </div>
          <hr />

          <section className="chartBox_area">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* Select City */}
                <div className="col-md-6 mt-3">
                  <label htmlFor="citySelect">
                    Select City<span className="text-danger">*</span>
                  </label>
                  <select
                    id="citySelect"
                    className="form-control"
                    value={cityId}
                    onChange={(e) => setCityId(e.target.value)}
                    required
                  >
                    <option value="" disabled>
                      ---Select City---
                    </option>
                    {cities.map((city) => (
                      <option key={city._id} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Select Date */}
                <div className="col-md-6 mt-3">
                  <label htmlFor="datePicker">
                    Select Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="datePicker"
                    className="form-control"
                    value={rawDate}
                    onChange={(e) => setRawDate(e.target.value)}
                    required
                  />
                </div>
              </div>

              {/* Submit Button */}
              <div className="row mt-4">
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      padding: "10px 30px",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <i className="fa-solid fa-spinner fa-spin me-2"></i>
                        Adding...
                      </>
                    ) : (
                      "Add City Date"
                    )}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary mt-3 ml-2"
                    style={{
                      borderRadius: "13px",
                      padding: "10px 30px",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                    onClick={clearForm}
                  >
                    Clear Form
                  </button>
                </div>
              </div>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
}

export default AddCityDate;
